define(function (require) {
    "use strict";

	var LE = require("app");
    var Config = require("manager-assets/config/config.json");
    var ManagerModuleLayout = require("manager-views/ManagerModuleLayout");
    var ManagerRouteController = require("manager-controllers/ManagerRouteController");
    var DataManagerController = require("manager-controllers/DataManagerController");
    var ManagerDataManager = require("manager-controllers/data/ManagerDataManager");
    var MetricsDataSourcesController = require("manager-controllers/MetricsDataSourcesController");
    var ADSGoogleAnalyticsHelper = require("manager-components/google-analytics/controllers/ADSGoogleAnalyticsHelper");
    var StringFormats = require("utils/StringFormats");

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {
        var moduleLayout;
        var oldDataManager;
        var dataManager;
        var moduleRouteController;

        // Expose the public (cross modules) handlers on the module channel
        (function() {
            LEManager.channel.comply(LE.mediaCodes.manager.commands.openScheduleGallery, function(path) {
                LEManager.router.navigate(path);
            });

            LEManager.channel.comply(LE.mediaCodes.manager.commands.openSpecialOccasionGallery, function(path) {
                LEManager.router.navigate(path);
            });

            // Expose Google Analytics get profiles
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.profilesGA, function(options) {
                return LE.authority.promise(function (promise) {
                    LEManager.ADSGoogleAnalyticsHelper.getProfiles(
                        function(collection) {
                            promise.complete(options.context, { collection: collection });
                        },
                        function() {
                            promise.error(options.context);
                        });
                });
            });

            // Expose Google Analytics get profile campaigns
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.profileCampaignsGA, function(options) {
                return LE.authority.promise(function (promise) {
                    LEManager.ADSGoogleAnalyticsHelper.getProfileCampaigns(options.selectedProfileModel,
                        function(profileModel, collection) {
                            promise.complete(options.context, { model: profileModel, collection: collection });
                        },
                        function() {
                            promise.error(options.context);
                        });
                });
            });

            // Expose Google Analytics get profile campaigns
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.profileUrlsGA, function(options) {
                return LE.authority.promise(function (promise) {
                    LEManager.ADSGoogleAnalyticsHelper.getProfileUrls(options.selectedProfileModel,
                        function(profileModel, collection) {
                            promise.complete(options.context, { model: profileModel, collection: collection });
                        },
                        function() {
                            promise.error(options.context);
                        });
                });
            });

            // Expose Google Analytics get profile campaign keywords
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.profileCampaignKeywordsGA, function(options) {
                return LE.authority.promise(function (promise) {
                    LEManager.ADSGoogleAnalyticsHelper.getProfileCampaignKeywords(options.selectedProfileModel, options.selectedCampaignModel,
                        function(profileModel, campaignModel, collection) {
                            promise.complete(options.context, { profileModel: profileModel, campaignModel: campaignModel,  collection: collection });
                        },
                        function() {
                            promise.error(options.context);
                        });
                });
            });

            // Expose Google Analytics get profile campaign Name
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.profileCampaignNameGA, function(options) {
                return LE.authority.promise(function (promise) {
                    LEManager.ADSGoogleAnalyticsHelper.getProfileCampaignName(options.profileId, options.campaignId,
                        function(campaignName) {
                            promise.complete(options.context, { name: campaignName });
                        },
                        function() {
                            promise.error(options.context);
                        });
                });
            });

            // Expose Google Analytics get connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.connectionStatusGA, function(options) {
                return LE.authority.promise(function (promise) {
                    LEManager.ADSGoogleAnalyticsHelper.getConnectionStatus(
                        function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        function() {
                            promise.error(options.context);
                        });
                });
            });

            // get Cart Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isCartConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.CART_EVENT
                    });
                });
            });

            // get Marketing Info Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isMarketingInfoConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.MARKETING_INFO_EVENT
                    });
                });
            });

            // get Transaction Info Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isTransactionConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.TRANSACTION_INFO_EVENT
                    });
                });
            });

            // get Lead Info Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isLeadConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.LEAD_INFO_EVENT
                    });
                });
            });

            // get Viewed Product Info Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isViewedProductConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.VIEWED_PRODUCT_EVENT
                    });
                });
            });

            // get Customer Info Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isCustomerInfoConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.CUSTOMER_INFO_EVENT
                    });
                });
            });

            // get service activity Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isServiceActivityConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.SERVICE_ACTIVITY_EVENT
                    });
                });
            });

            // get Visitor Error Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isVisitorErrorConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.VISITOR_ERROR_EVENT
                    });
                });
            });

            // get Personal Details Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isPersonalInfoConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.PERSONAL_INFO_EVENT
                    });
                });
            });

            // get Location Sections Metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isLocationSectionsConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.LOCATION_SECTIONS_EVENT
                    });
                });
            });

            // get Authentication Server metrics connection status
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.isAuthenticationServerConnectedDS, function(options) {
                return LE.authority.promise(function (promise) {
                    MetricsDataSourcesController.isMetricsConnected({
                        success: function(isConnected) {
                            promise.complete(options.context, {isConnected: isConnected});
                        },
                        error: function () {
                            promise.error(options.context);
                        },
                        types: MetricsDataSourcesController.METRIC_TYPES.AUTHENTICATION_SERVER_EVENT
                    });
                });
            });

            // get the Categories collection from the data manager
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.getCategories, function() {
                return LEManager.getDataManager().getCategoriesCollection();
            });

            LEManager.channel.reply(LE.mediaCodes.manager.reqres.getSchedulesCollection, function() {
                return LEManager.getModuleDataManager().getSchedulesCollection();
            });

            LEManager.channel.reply(LE.mediaCodes.manager.reqres.getSpecialOccasionsCollection, function() {
                return LEManager.getModuleDataManager().getSpecialOccasionsCollection();
            });

            LEManager.channel.reply(LE.mediaCodes.manager.reqres.getSiteSettingsManualShiftStatusModel, function() {
                return LEManager.getModuleDataManager().getSiteSettingsManualShiftStatusModel();
            });

            // get the Categories collection from the data manager
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.getCategoriesValidators, function() {
                return Config.validators.categories;
            });

            // get on object that includes the categories server error translations
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.getCategoriesServerErrors, function() {
                return {
                    maximumEntities: LE.translator.translate("LEManager.categories.errors.categories.maximum"),
                    duplicateName: LE.translator.translate("LEManager.categories.errors.categoryName.duplicate")
                };
            });
            LEManager.channel.reply(LE.mediaCodes.manager.reqres.getApiKeysCollection, function() {
                return LEManager.getModuleDataManager().getApiKeysCollection();
            });

            LEManager.channel.reply(LE.mediaCodes.manager.reqres.getAuthenticationServerCollection, function() {
                var collection = LEManager.getModuleDataManager().getAuthenticationServerCollection();
                return collection;
            });

            // TODO: Add the other handlers to be exposed by the module
        })();

        LEManager.addInitializer(function () {
            moduleLayout = new ManagerModuleLayout();
            dataManager = new ManagerDataManager({
                module:{
                    mainRegion: LEManager.getMainRegion(),
                    showLoader: LEManager.showLoader,
                    closeLoader: LEManager.closeLoader,
                    notifier: LEManager.notifier
                }
            });
            oldDataManager = new DataManagerController();
            oldDataManager.start();
            moduleRouteController = new ManagerRouteController();

            LEManager.ADSGoogleAnalyticsHelper = ADSGoogleAnalyticsHelper;
        });

        LEManager.getMainView = function () {
            return moduleLayout;
        };

        LEManager.getMainRegion = function () {
            return moduleLayout.mainRegion;
        };

        LEManager.getRouteController = function () {
            return moduleRouteController;
        };

        LEManager.getDataManager = function() {
            return oldDataManager;
        };
        LEManager.getModuleDataManager = function() {
            return dataManager;
        };

        LEManager.showLoader = function(options) {
            moduleLayout.showLoader(options);
        };

        LEManager.closeLoader = function() {
            moduleLayout.closeLoader();
        };

        LEManager.getGeneralErrorMsg = function(errorObject) {
            return  StringFormats.getGeneralErrorMsg(errorObject);
        };

        LEManager.lockReporting = true;
    });


    return LE.module("LEManager");
});
